module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9613.2ec09505.jpg";